<template>
    <div style="min-height:450px;border-radius:8px" class="card pt-0 mb-3 bg-white px-3 py-3">
        <div class="row">
            <h4 class="card-title pl-3 pb-2 mb-0">Kehadiran Tepat Waktu</h4>
        </div>
        <div class="row no-gutters">
            <div class="col-md-1">
                <hr class="border-primary"/>
            </div>
            <div class="col-md-11">
                <hr/>
            </div>
        </div>
        <div id="chart">
            <apexchart type="bar" height="330" v-if="status == true" :options="chartOptions" :series="series"></apexchart>
        </div>
    </div>
</template>

<script>
export default {
    props: ['snt', 'snnt', 'slt', 'slnt', 'rbt', 'rbnt', 'kmt', 'kmnt', 'jmt', 'jmnt', 'sbt', 'sbnt', 'mgt', 'mgnt'],
    data() {
        return {
            status: false,
            series: [
            {
                data: [0,0,0,0,0],
                name: 'Tepat Waktu',
                colors: 'blue'
            },
            {
                data: [0,0,0,0,0],
                name: 'Telat',
                colors: 'red'
            }
            ],
            chartOptions: {
                chart: {
                    type: 'bar',
                    height: 250,
                    stackType: '100%'
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                    }
                },
                colors: ['#008FFB', '#FF4560'],
                dataLabels: {
                    enabled: true,
                    offsetX: 0,
                    style: {
                        fontSize: '10px',
                        colors: ['#fff']
                    }
                },
                stroke: {
                    show: true,
                    width: 1,
                    colors: ['#fff']
                },
                xaxis: {
                    categories: [],
                    labels: {
                        style: {
                            colors: []
                        }
                    }
                },
                yaxis: {
                    labels: {
                        formatter: function (val) {
                            let showVal = 0
                            if(val > 99) {
                                showVal = 100
                            } else {
                                showVal = val
                            }
                            return showVal + "%"
                        }
                    }
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + "%"
                        }
                    }
                },
            },
        }
    },
    watch: {
        snt() {
            this.getData()
        },
        snnt() {
            this.getData()
        },
        slt() {
            this.getData()
        },
        slnt() {
            this.getData()
        },
        rbt() {
            this.getData()
        },
        rbnt() {
            this.getData()
        },
        kmt() {
            this.getData()
        },
        kmnt() {
            this.getData()
        },
        jmt() {
            this.getData()
        },
        jmnt() {
            this.getData()
        },
        sbt() {
            this.getData()
        },
        sbnt() {
            this.getData()
        },
        mgt() {
            this.getData()
        },
        mgnt() {
            this.getData()
        }
    },
    methods: {
        getData() {
            let presentaseSeninTepat = 0
            let presentaseSeninTelat = 0
            if(this.snnt != '') {
                let seninTepat = parseInt(this.snnt)
                let seninTelat = parseInt(this.snt)
                let totalSenin = seninTepat + seninTelat
                presentaseSeninTepat = Math.floor((seninTepat/totalSenin)*100)
                presentaseSeninTelat = Math.floor((seninTelat/totalSenin)*100)
                this.chartOptions.xaxis.labels.style.colors.push("#008FFB")
            }

            let presentaseSelasaTepat = 0
            let presentaseSelasaTelat = 0
            if(this.slnt != '') {
                let selasaTepat = parseInt(this.slnt)
                let selasaTelat = parseInt(this.slt)
                let totalSelasa = selasaTepat + selasaTelat
                presentaseSelasaTepat = Math.floor((selasaTepat/totalSelasa)*100)
                presentaseSelasaTelat = Math.floor((selasaTelat/totalSelasa)*100)
                this.chartOptions.xaxis.labels.style.colors.push("#008FFB")
            }

            let presentaseRabuTepat = 0
            let presentaseRabuTelat = 0
            if(this.rbnt != '') {
                let rabuTepat = parseInt(this.rbnt)
                let rabuTelat = parseInt(this.rbt)
                let totalRabu = rabuTepat + rabuTelat
                presentaseRabuTepat = Math.floor((rabuTepat/totalRabu)*100)
                presentaseRabuTelat = Math.floor((rabuTelat/totalRabu)*100)
                this.chartOptions.xaxis.labels.style.colors.push("#008FFB")
            }

            let presentaseKamisTepat = 0
            let presentaseKamisTelat = 0
            if(this.kmnt != '') {
                let kamisTepat = parseInt(this.kmnt)
                let kamisTelat = parseInt(this.kmt)
                let totalKamis = kamisTepat + kamisTelat
                presentaseKamisTepat = Math.floor((kamisTepat/totalKamis)*100)
                presentaseKamisTelat = Math.floor((kamisTelat/totalKamis)*100)
                this.chartOptions.xaxis.labels.style.colors.push("#008FFB")
            }

            let presentaseJumatTepat = 0
            let presentaseJumatTelat = 0
            if(this.jmnt != '') {
                let jumatTepat = parseInt(this.jmnt)
                let jumatTelat = parseInt(this.jmt)
                let totalJumat = jumatTepat + jumatTelat
                presentaseJumatTepat = Math.floor((jumatTepat/totalJumat)*100)
                presentaseJumatTelat = Math.floor((jumatTelat/totalJumat)*100)
                this.chartOptions.xaxis.labels.style.colors.push("#008FFB")
            }

            let presentaseSabtuTepat = 0
            let presentaseSabtuTelat = 0
            if(this.sbnt != '') {
                let sabtuTepat = parseInt(this.sbnt)
                let sabtuTelat = parseInt(this.sbt)
                let totalSabtu = sabtuTepat + sabtuTelat
                presentaseSabtuTepat = Math.floor((sabtuTepat/totalSabtu)*100)
                presentaseSabtuTelat = Math.floor((sabtuTelat/totalSabtu)*100)
                this.chartOptions.xaxis.labels.style.colors.push("#008FFB")
            }

            let presentaseMingguTepat = 0
            let presentaseMingguTelat = 0
            if(this.mgnt != '') {
                let mingguTepat = parseInt(this.mgnt)
                let mingguTelat = parseInt(this.mgt)
                let totalMinggu = mingguTepat + mingguTelat
                presentaseMingguTepat = Math.floor((mingguTepat/totalMinggu)*100)
                presentaseMingguTelat = Math.floor((mingguTelat/totalMinggu)*100)
                this.chartOptions.xaxis.labels.style.colors.push("#008FFB")
            }

            let date = new Date()
            let day = date.getDay()
            var i
            let sub = 4
            for(i=0;i<5;i++) {
                let days = day - sub
                if(days == 0) {
                    this.series[0].data[i] = presentaseMingguTepat
                    this.series[1].data[i] = presentaseMingguTelat
                } else if(days == 1) {
                    this.series[0].data[i] = presentaseSeninTepat
                    this.series[1].data[i] = presentaseSeninTelat
                } else if(days == 2) {
                    this.series[0].data[i] = presentaseSelasaTepat
                    this.series[1].data[i] = presentaseSelasaTelat
                } else if(days == 3 || days == -4) {
                    this.series[0].data[i] = presentaseRabuTepat
                    this.series[1].data[i] = presentaseRabuTelat
                } else if(days == 4 || days == -3) {
                    this.series[0].data[i] = presentaseKamisTepat
                    this.series[1].data[i] = presentaseKamisTelat
                } else if(days == 5 || days == -2) {
                    this.series[0].data[i] = presentaseJumatTepat
                    this.series[1].data[i] = presentaseJumatTelat
                } else if(days == 6 || days == -1) {
                    this.series[0].data[i] = presentaseSabtuTepat
                    this.series[1].data[i] = presentaseSabtuTelat
                }
                // this.chartOptions.xaxis.categories.push(conv)
                sub -= 1
            }

            // this.series[0].data[0] = presentaseSeninTepat
            // this.series[0].data[1] = presentaseSelasaTepat
            // this.series[0].data[2] = presentaseRabuTepat
            // this.series[0].data[3] = presentaseKamisTepat
            // this.series[0].data[4] = presentaseJumatTepat
            // this.series[1].data[0] = presentaseSeninTelat
            // this.series[1].data[1] = presentaseSelasaTelat
            // this.series[1].data[2] = presentaseRabuTelat
            // this.series[1].data[3] = presentaseKamisTelat
            // this.series[1].data[4] = presentaseJumatTelat
            this.status = true
        },
        label() {
            return 'coba label'
        },
        getDay() {
            let date = new Date()
            let day = date.getDay()
            var i
            let sub = 4
            for(i=0;i<5;i++) {
                let days = day - sub
                let conv = ''
                if(days == 0) {
                    conv = 'Minggu'
                } else if(days == 1) {
                    conv = 'Senin'
                } else if(days == 2) {
                    conv = 'Selasa'
                } else if(days == 3 || days == -4) {
                    conv = 'Rabu'
                } else if(days == 4 || days == -3) {
                    conv = 'Kamis'
                } else if(days == 5 || days == -2) {
                    conv = 'Jumat'
                } else if(days == 6 || days == -1) {
                    conv = 'Sabtu'
                }
                this.chartOptions.xaxis.categories.push(conv)
                sub -= 1
            }
        }
    },
    mounted() {
        this.getDay()
    },
}
</script>

<style scoped>
.card-title {
    font-size: 18px;
    color: rgba(0, 0, 0, 1);
}
</style>